import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ReviewsGallery } from '../components/ReviewsGallery';
export function TestimonialsPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="pt-[64px] md:pt-[72px]" data-id="element-1348">
      {/* HERO */}
      <section className="bg-brand-beige section-padding relative overflow-hidden" data-id="element-1349">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-1350"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-coral/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3 pointer-events-none" data-id="element-1351"></div>
        <div className="container-custom relative z-10" data-id="element-1352">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1353">
            <span className="inline-block px-4 py-1.5 rounded-full bg-brand-coral/10 text-brand-coral font-montserrat font-bold text-[12px] tracking-wider uppercase mb-6" data-id="element-1354">
              Recenzii reale de la mame
            </span>
            <h1 className="font-playfair text-[40px] md:text-[56px] font-bold text-brand-navy mb-6 leading-[1.1]" data-id="element-1355">
              Mărturii care arată că progresul este posibil
            </h1>
            <p className="font-playfair italic text-brand-coral text-[22px] md:text-[26px] mb-6 leading-[1.4]" data-id="element-1356">
              „Atunci când o mamă primește ghidarea potrivită, copilul ei începe
              să înflorească."
            </p>
            <p className="font-source text-brand-textSecondary" data-id="element-1357">
              Fiecare imagine de mai jos este un mesaj real, exact așa cum mi-a
              fost trimis — cu lacrimi, cu recunoștință și, mai ales, cu
              speranța că lucrurile se pot schimba. Click pe orice mesaj pentru
              a-l citi integral.
            </p>
          </div>
        </div>
      </section>

      {/* GALLERY */}
      <section className="bg-brand-ivory section-padding" data-id="element-1358">
        <div className="container-custom" data-id="element-1359">
          <ReviewsGallery data-id="element-1360" />
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="bg-brand-navy section-padding text-white relative overflow-hidden" data-id="element-1361">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-1362"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-coral/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3 pointer-events-none" data-id="element-1363"></div>
        <div className="container-custom relative z-10" data-id="element-1364">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1365">
            <span className="inline-block px-4 py-1.5 rounded-full bg-brand-gold/20 text-brand-gold font-montserrat font-bold text-[12px] tracking-wider uppercase mb-6" data-id="element-1366">
              Următorul pas
            </span>
            <h2 className="font-playfair text-[32px] md:text-[48px] font-bold text-white mb-6 leading-[1.15]" data-id="element-1367">
              Și povestea ta poate arăta așa
            </h2>
            <p className="font-source text-white/85 mb-4" data-id="element-1368">
              Fiecare mărturie de mai sus a început exact ca a ta: cu o mamă
              care nu mai știa pe cine să întrebe, cu îndoieli, cu nopți
              pierdute căutând răspunsuri. Diferența nu a venit dintr-un miracol
              — a venit dintr-un singur pas făcut în direcția potrivită.
            </p>
            <p className="font-source text-white/85 mb-10" data-id="element-1369">
              Poți face și tu primul pas astăzi: descarcă ghidul gratuit dacă
              vrei să începi să înțelegi, sau programează o evaluare dacă simți
              că ai nevoie de un răspuns clar despre copilul tău. Sunt aici să
              te ghidez, cu blândețe și fără să te judec.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1370">
              <Link to="/evaluarecadou" className="btn-inverted text-[16px]" data-id="element-1371">
                Programează o Evaluare
              </Link>
              <Link to="/resursegratuite" className="font-montserrat font-medium text-[14px] text-brand-gold hover:underline" data-id="element-1372">
                Sau descarcă întâi ghidul gratuit →
              </Link>
            </div>
          </div>
        </div>
      </section>
    </motion.div>;
}